export default "__VITE_ASSET__8c9945c1__"